// extracted by mini-css-extract-plugin
export default {"loading":"index-module__loading--vKuwI","circle":"index-module__circle--g0Yjh"};